import React from "react";
import { Table, Alert, Spin } from "antd";
import { ReloadOutlined, ToolOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../../Components/Items";
import { ESTADO_VERIFICACION } from "../aguinaldoUtils";

/**
 * Paso 4 — revisa que los conceptos, acumulados, cuentas y tablas que necesita el aguinaldo estén
 * bien dados de alta, y con un botón da de alta o corrige lo que falte. Lo marcado "Revisar a
 * mano" no lo puede arreglar el asistente (duplicados, catálogos del sistema).
 */
const PasoConceptos = ({ verificacion, cargando, asegurando, soloLectura, onVerificar, onAsegurar }) => {
  const columnas = [
    { title: "Revisión", dataIndex: "titulo", width: 220, render: (t) => <b>{t}</b> },
    {
      title: "Estado",
      dataIndex: "estado",
      width: 150,
      render: (e, v) => {
        const info = ESTADO_VERIFICACION[e] || ESTADO_VERIFICACION.aviso;
        return (
          <span style={{ color: info.color, fontWeight: 500 }}>
            {info.texto}
            {v.bloqueante && e !== "correcto" && (
              <span className="aguinaldo-tenue" style={{ display: "block", fontWeight: 400 }}>
                Necesario para continuar
              </span>
            )}
          </span>
        );
      },
    },
    { title: "Detalle", dataIndex: "detalle" },
  ];

  const lista = verificacion?.verificaciones || [];
  const soloRevisarAMano = verificacion?.hayBloqueantes && !verificacion?.hayCorregibles;

  return (
    <div className="aguinaldo-paso">
      <div className="aguinaldo-bandeja-cabecera">
        <div>
          <div className="aguinaldo-titulo">Conceptos del aguinaldo</div>
          <div className="aguinaldo-tenue">
            La percepción Aguinaldo (SAT 002, exención de 30 UMA) y la deducción I.S.R. Art. 174 (tasa
            efectiva) con sus acumulados. Lo que ya tengas bien no se toca; las fórmulas y cuentas sólo
            se llenan si están vacías.
          </div>
        </div>
        <ButtonItem icon={<ReloadOutlined />} onClick={onVerificar} loading={cargando}>
          Volver a revisar
        </ButtonItem>
      </div>

      <Spin spinning={!!cargando && !verificacion}>
        <Table
          rowKey="clave"
          size="small"
          columns={columnas}
          dataSource={lista}
          pagination={false}
          loading={!!cargando && !!verificacion}
        />
      </Spin>

      {verificacion && (
        <div style={{ marginTop: 16 }}>
          {verificacion.hayCorregibles && !soloLectura && (
            <ButtonItem type="primary" icon={<ToolOutlined />} loading={asegurando} onClick={onAsegurar}>
              Dar de alta / corregir
            </ButtonItem>
          )}
          {!verificacion.hayBloqueantes && (
            <Alert type="success" showIcon message="Todo listo: puedes continuar al resumen." />
          )}
          {soloRevisarAMano && (
            <Alert
              type="error"
              showIcon
              message="Hay pendientes que el asistente no puede corregir. Revísalos en el catálogo indicado y vuelve a revisar."
            />
          )}
        </div>
      )}
    </div>
  );
};

export default PasoConceptos;
